import React, {useContext, useState} from 'react'
import {Navigate, Outlet} from "react-router-dom";
import API from "../../api/api";

const AuthenticationContext = React.createContext({
    isAuthenticated: false,
    errors: false,
    login: () => {},
    logout: () => {},
    reset: () => {}
})
const client = API.instance()

function SecuredApp({children}) {
    // TODO: FIX AUTHENTICATION
    const [isAuthenticated, setIsAuthenticated] = useState(JSON.parse(sessionStorage.getItem('authenticated') || false))
    const [errors, setErrors] = useState(false)

    const reset = async () => {
        sessionStorage.setItem('authenticated', JSON.stringify(false))
        setErrors(false)
        setIsAuthenticated(false)
    }
    const login = async (user, pass) => {
        const loginSuccessful = await client.login(user, pass)
        sessionStorage.setItem('authenticated', JSON.stringify(loginSuccessful))
        setErrors(!loginSuccessful)
        setIsAuthenticated(loginSuccessful)
    }
    const logout = async () => {
        await client.logout()
        await reset()
    }

    const context = { isAuthenticated, login, logout, errors, reset }

    return <AuthenticationContext.Provider value = { context } >
        { children }
    </AuthenticationContext.Provider>

}

/*function SecuredRoute({children, ...props}) {
    const {isAuthenticated} = useContext(AuthenticationContext)
    return isAuthenticated ? <Route {...props}>{children}</Route> : <Route element={<Navigate to = '/login' />}></Route>
}*/

const AuthLayout = () => {

    const {isAuthenticated} = useContext(AuthenticationContext);
    return isAuthenticated ? <Outlet /> : <Navigate to={"/login"} replace />;
};

export { AuthenticationContext, SecuredApp, AuthLayout }